import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../utils/cn';

function FormInput({
  label,
  hint,
  error,
  type = 'text',
  textarea,
  rows,
  ...rest
}) {
  // For password fields, wrap the input in a row with a show/hide eye
  // button. Setting `type` locally lets us swap between 'password' and
  // 'text' without breaking the caller's own type prop. Applies to every
  // password field platform-wide (client 2026-08-21).
  const [showPw, setShowPw] = useState(false);
  const isPassword = !textarea && type === 'password';

  if (isPassword) {
    return (
      <div className="field">
        {label && <label>{label}</label>}
        <div
          className="row"
          style={{
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '8px 12px',
            background: 'var(--surface)',
            gap: 8,
          }}
        >
          <input
            type={showPw ? 'text' : 'password'}
            className={cn(error && 'is-error')}
            style={{
              flex: 1,
              border: 0,
              outline: 'none',
              background: 'transparent',
              fontSize: 16,
              minWidth: 0,
            }}
            {...rest}
          />
          <button
            type="button"
            onClick={() => setShowPw((v) => !v)}
            aria-label={showPw ? 'Hide password' : 'Show password'}
            style={{ background: 'transparent', border: 0, cursor: 'pointer', color: 'var(--ink-500)' }}
          >
            {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        {error ? <div className="err">{error}</div> : hint ? <div className="hint">{hint}</div> : null}
      </div>
    );
  }

  const Tag = textarea ? 'textarea' : 'input';
  return (
    <div className="field">
      {label && <label>{label}</label>}
      <Tag
        type={textarea ? undefined : type}
        rows={textarea ? rows || 4 : undefined}
        className={cn(textarea ? 'textarea' : 'input', error && 'is-error')}
        {...rest}
      />
      {error ? <div className="err">{error}</div> : hint ? <div className="hint">{hint}</div> : null}
    </div>
  );
}

export default FormInput;
